import { put, takeEvery, all, call, select } from 'redux-saga/effects'
import * as Actions from 'actions/anewstip'
import * as AppActions from 'actions/app'
import * as ContactManagementActions from 'actions/contact_management'
import * as Selectors from 'selectors'
import * as Api from 'api/contacts_management'

export function* importStart({ payload }) {
  const i18n = yield select(Selectors.getI18n)
  const distributionListFormData = yield select(Selectors.getCmDaDistributionListFormData)

  let body

  try {
    if (payload && payload.id) {
      body = {
        ids: [payload.id]

      }
    } else {
      const selected = yield select(Selectors.getAnewstipSelectedData)
      body = {
        ids: selected.get('journalists')
      }

      // we now use the import route which allows us to add journalists to distribution lists
      // so it's not necessary to have a separate action for this
      if (distributionListFormData) {
        const distributionListIds = distributionListFormData.get('selectedLists')
        const newDistributionListNames = distributionListFormData.get('newListNames')

        if (!distributionListIds.isEmpty()) {
          body.distribution_list_ids = distributionListIds.toJS()
        }

        if (!newDistributionListNames.isEmpty()) {
          body.new_distribution_lists = newDistributionListNames.toJS()
        }
      }
    }

    const result = yield call(Api.importAnewstipContacts, body)

    yield put(Actions.importSuccess(result))
    yield put(Actions.hideDistributionListCreateDialog())
    yield put(ContactManagementActions.updateDistributionListFormData({ key: 'selectedLists', value: [] }))
    yield put(ContactManagementActions.updateDistributionListFormData({ key: 'newListNames', value: [] }))

    yield put(AppActions.showAppSnackbarMessage({
      text: i18n.get('contact_added'),
      variant: 'success'
    }))
  } catch (error) {
    yield put(Actions.importError(error))

    if (error.response && error.response.message) {
      yield put(AppActions.showAppSnackbarMessage({
        text: error.response.message,
        variant: 'error'
      }))
    }
  }
}

export function* watchImportStart() {
  yield takeEvery(Actions.importStart, importStart)
}

export function* watchAddJournalistToDistributionListStart() {
  yield takeEvery(Actions.addJournalistsToDistributionList, importStart)
}

export default function* importSaga() {
  yield all([
    watchImportStart(),
    watchAddJournalistToDistributionListStart()
  ])
}
